const RELOAD_AT_KEY = "tm:stale-chunk-reload-at";
/** Mindestabstand, damit Reload-Loops bei anhaltend kaputtem Deploy enden. */
const RELOAD_COOLDOWN_MS = 12_000;

/**
 * Hard-Reload nach fehlgeschlagenem Lazy-Chunk (Deploy/CDN-Mix).
 * Erlaubt einen zweiten Versuch nach Cooldown — nicht dauerhaft sperren.
 * @returns {boolean} true wenn Reload ausgelöst wurde
 */
export function reloadAfterStaleChunk() {
  try {
    const prev = Number(sessionStorage.getItem(RELOAD_AT_KEY) || 0);
    const now = Date.now();
    if (Number.isFinite(prev) && prev > 0 && now - prev < RELOAD_COOLDOWN_MS) {
      return false;
    }
    sessionStorage.setItem(RELOAD_AT_KEY, String(now));
  } catch (_) {
    /* ignore */
  }
  try {
    // Cache-Bypass: neues Document laden (nicht nur Memory-Reload).
    const url = new URL(window.location.href);
    url.searchParams.set("_tmr", String(Date.now()));
    window.location.replace(url.toString());
  } catch (_) {
    window.location.reload();
  }
  return true;
}

export function clearStaleChunkReloadMarker() {
  try {
    sessionStorage.removeItem(RELOAD_AT_KEY);
    sessionStorage.removeItem("tm:stale-chunk-reload");
    sessionStorage.removeItem("tm:chunk-reload");
  } catch (_) {
    /* ignore */
  }
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.has("_tmr")) {
      url.searchParams.delete("_tmr");
      window.history.replaceState(
        null,
        "",
        `${url.pathname}${url.search}${url.hash}`,
      );
    }
  } catch (_) {
    /* ignore */
  }
}

export function isStaleChunkError(err) {
  const msg = String(err?.message || err || "").toLowerCase();
  return (
    msg.includes("mime type") ||
    msg.includes("dynamically imported module") ||
    msg.includes("failed to fetch") ||
    msg.includes("load failed") ||
    msg.includes("stale chunk") ||
    msg.includes("no module") ||
    msg.includes("exported no component") ||
    msg.includes("undefined is not an object") ||
    msg.includes("cannot read propert") ||
    msg.includes("loading chunk") ||
    msg.includes("importing a module script failed")
  );
}
